import { AbstractExternalAPIHandler } from './AbstractExternalAPIHandler';
import { CompRef, ValueOf } from '@wix/document-services-types';
import { Presets } from '@wix/component-protocol/schema';
import { DependencyToken } from '../dependencies';
import type { ContainerLayoutTransitionConfig } from '../types';
import type { EditorPointer } from '@wix/editor-document-logic-api';

export class ExternalLayoutHandler extends AbstractExternalAPIHandler {
  applyComponentResize(
    editorPointer: EditorPointer<CompRef>,
    targetSize: ValueOf<Presets>['initialSize'],
  ) {
    const getContainer = this.dependenciesContributor.get(
      DependencyToken.COMPONENTS_CONTAINER_GET,
    );
    const containerDocumentPointer = getContainer(
      editorPointer.documentPointer,
    );
    const parentPointer = containerDocumentPointer
      ? this.editorPointerAPI.buildEditorPointer(containerDocumentPointer)
      : undefined;

    const updateLayout = this.dependenciesContributor.get(
      DependencyToken.LAYOUT_COMPONENT_UPDATE,
    );

    updateLayout({
      editorPointer,
      targetSize,
      parentPointer,
    });
  }

  regenerateContainerLayout(
    editorPointer: EditorPointer<CompRef>,
    containerLayoutTransitionConfig: ContainerLayoutTransitionConfig,
  ) {
    const regenerateContainerLayout = this.dependenciesContributor.get(
      DependencyToken.LAYOUT_CONTAINER_REGENERATE,
    );

    regenerateContainerLayout({
      editorPointer,
      containerLayoutTransitionConfig,
    });
  }
}
